import border from '../../border';

const secondary = (params) => border.disabled.secondary(params);

export default secondary;
